
// @ts-ignore
import {translate} from '@elements/translations';
import { defineComponent } from "vue";
import NumberSpinner from "~vue/components/form-elements/NumberSpinner.vue";

export default defineComponent({
    name: 'PriceGroupItem',
    components: {
        NumberSpinner
    },
    props: {
       title: {
           type: String,
           required: true,
       },
        isAvailable: {
           type: Boolean,
            required: true,
        },
        imgName: {
           type: String,
            required: true,
        },
        description: {
           type: String,
            required: true,
        },
        price: {
           type: Number,
            required: true,
        },
        counter: {
           type: Number,
            required: true,
        },
        maxCounter: {
           type: Number,
            required: true,
        },
        minCounter: {
           type: Number,
            required: false,
            default: 0
        },
        id: {
           type: String,
            required: true,
        },
    },
    emits: ['changeCounter'],
    setup(props, { emit }) {
        return {
            translate,
            emit,
        };
    }
});
